<template>
  <div class="dayplanner-suggestions p-0" style="overflow: hidden;">

    <!-- v-if="$ready_contacts" -->
    <!-- TODO: Allow to organize users in categories (like goals) see <inline-goal-list /> -->

    <div v-if="special_menu_active === 'inbox'" class="p-3">
      <el-button @click="onGoBack" size="small">
        &larr; Go back
      </el-button>

      <h5 class="mt-2 text-center">Incomming tasks</h5>
      <hr />

      <IncommingTasks direction="incomming" />

    </div>
    <div v-else-if="special_menu_active === 'outbox'" class="p-3">
      <el-button @click="onGoBack" size="small">
        &larr; Go back
      </el-button>

      <h5 class="mt-2 text-center">Outgoing tasks</h5>
      <hr />

      <IncommingTasks direction="outgoing" />

    </div>
    <template v-else-if="selected_user === null">
      <div class="user-contact-list p-3">
        <!-- <el-badge is-dot v-if="message.unread"></el-badge> -->
        <inline-user-card
          class="mt-2"
          v-for="contact in contacts_sorted"
          :key="contact.$key"
          :user-id="contact.contactUserId"
          @select="onSelectUser"
          />
      </div>

      <hr />

      <el-card class="m-3" body-style="padding: 1em">
        <div @click="onSelectInbox" class="clickable">
          <!-- <font-awesome-icon icon="inbox" /> -->
          <font-awesome-icon icon="arrow-down" />
          <span class="ml-2">Sell all incomming tasks</span>
        </div>
      </el-card>

      <el-card class="m-3" body-style="padding: 1em">
        <div @click="onSelectOutbox" class="clickable">
          <font-awesome-icon icon="arrow-up" />
          <span class="ml-2">Sell all outgoing tasks</span>
        </div>
      </el-card>
    </template>

    <div v-else class="d-flex flex-column">
      <div class="p-3">
        <el-button @click="onGoBack" size="small">
          &larr; Go back
        </el-button>

        <!-- TODO: Popover!?
        <div style="float: right">
          <a
            v-if="!hide_user_details"
            href="#"
            @click.prevent="hide_user_details = true">hide user details</a>
          <a
            v-else
            href="#"
            @click.prevent="hide_user_details = false">show user details</a>
        </div>

        <el-card class="mt-2 mx-0 px-0" v-if="!hide_user_details">
          <UserContactDetails :contact-id="selected_user" />
        </el-card>
        -->
      </div>

      <!-- <div style="border: 2px solid red; height: 100%; overflow: scroll;"></div> -->

      <UserContactChat :contact-id="selected_user" />

      <!--
      <suggestion-drag-list :item-list="myday_suggestions" :clone="cloneItem">
        <component
          class="action-draggable"
          v-for="suggestion_item in myday_suggestions"
          v-bind:is="suggestion_item.componentSuggestion"
          :key="suggestion_item.$key"
          :item-id="suggestion_item.$id"
          :config="suggestion_item.config"
          :name="suggestion_item.title"
          :tsc-color="suggestion_item.color"
          @add="onAddSuggestionItem(commitment_suggestion_items.$id, suggestion_item, $event)"
        />
      </suggestion-drag-list>
      -->

    </div>

    <p v-if="contacts_sorted.length === 0" class="no-content">
      No contact found. Please invite some friends by clicking 'Add contact' in the right side bar.
    </p>

  <!--
  <component
    class="action-draggable"
    v-for="suggestion_item in suggestion_item_list.items"
    v-bind:is="suggestion_item.componentSuggestion"
    :key="suggestion_item.$key"
    :item-id="suggestion_item.$id"
    :type="suggestion_item.type"
    :config="suggestion_item.config"
    :name="suggestion_item.title"
    :date-timestamp="dateTimestamp"
    @add="onAddSuggestionItem(suggestion_item_list.$id, suggestion_item, $event)"
  />
  </suggestion-drag-list>
  -->

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { mapReady } from "@/api/misc";

// import SuggestionDragList from "./SuggestionDragList";
import SidebarMixin from '@/components/TodayPage/Elements/SidebarMixin'
import UserContactChat from '../Chat/UserContactChat'
import IncommingTasks from '../Chat/IncommingTasks'

// import UserContactDetails from '@/components/Elements/UserContactDetails'
// import { make_block } from "../API/util";

// import clonedeep from "lodash.clonedeep";
// import moment from "@/moment-gp.js";

export default {
  mixins: [ SidebarMixin ],
  props: {
  },
  data: () => ({
    hide_user_details: true,
    special_menu_active: null,
  }),
  mounted() {
    // TODO: Always scroll to bottom
    // TODO: Chat in own scroll container
  },
  computed: {
    ...mapReady("commitments"),
    ...mapGetters("dayplanner", [
      "view_selected_date",
      // "dayplan_remaining_timeslots",
      // "dayplan_from_db",
      // "view_selected_date_as_timestamp",
      // "view_selected_date_as_yymmdd",
    ]),
    ...mapGetters("app", [
      "active_user_chat",
    ]),

    selected_user() {
      return this.active_user_chat;
    },

    contacts_sorted() {
      return this.userContacts.itemsAsArray();
    },

    userContacts() {
      return this.$models.userContact.subscribeList();
    }
  },
  methods: {
    ...mapMutations("app", [
      "SET_ACTIVE_USER_CHAT",
    ]),

    onGoBack() {
      this.onSelectUser(null);
      this.special_menu_active = null;
    },

    onSelectUser( userId ) {
      console.log("onSelectUser", userId)
      // this.selected_user = userId;
      this.SET_ACTIVE_USER_CHAT( userId )
    },

    onSelectInbox() {
      this.SET_ACTIVE_USER_CHAT( null )
      this.special_menu_active = 'inbox';
    },

    onSelectOutbox() {
      this.SET_ACTIVE_USER_CHAT( null )
      this.special_menu_active = 'outbox';
    },
  },
  components: {
    UserContactChat,
    IncommingTasks,
    // UserContactDetails,
  }
};
</script>

<style>
</style>
